import React from 'react';
import { motion } from 'framer-motion';

const partners = [
  { name: 'BBB A+', logo: '/logos/BBBA+.png', link: 'https://www.bbb.org/us/fl/fort-lauderdale/profile/information-technology-services/sebastian-alliance-group-llc-0633-92048929' },
  { name: 'Caribbean Payments Alliance', logo: '/logos/CPALogo.png', link: 'https://caribbeanpaymentsalliance.com', tall: true },
  { name: 'BCA', logo: '/logos/BCAlogo.png' },
  { name: 'BCCEC', logo: '/logos/BCCECLogo.png' },
  { name: 'Visa', logo: '/logos/visaLogo.png', link: 'https://www.visa.com' },
  { name: 'Scotiabank', logo: '/logos/Scotiabank_loogo.png', link: 'https://www.scotiabank.com' },
  { name: 'NACHA', logo: '/logos/NachaLogo.png', link: 'https://www.nacha.org' },
  { name: 'SWIFT', logo: '/logos/SwiftLogo.png', link: 'https://www.swift.com' },
  { name: 'Sekur', logo: '/logos/Sekurlogo.png', link: 'https://sekursuite.com/en/sag' },
  { name: 'Intuit', logo: '/logos/Intuit.png', link: 'https://www.intuit.com' },
  { name: 'QuickBooks Advisor', logo: '/logos/QBA.png' },
  { name: 'QuickBooks Developer', logo: '/logos/QBDeveloper.png' },
  { name: 'APC EstateFlow', logo: '/logos/APCEstateFlow.png', link: 'https://apcestateflow.com', tall: true },
  { name: 'BahamasPay', logo: '/logos/BahamasPay.png', link: 'https://bahamaspay.com', tall: true },
  { name: 'CloudSync Pro', logo: '/logos/CloudSyncPro.png', link: 'https://csyncpro.com', tall: true },
  { name: 'RBC', text: 'RBC' },
  { name: 'Bank of The Bahamas', text: 'BOB' },
  { name: 'SunCash', text: 'SunCash' },
  { name: 'Plug\'n Pay', text: "Plug'n Pay" },
  { name: 'Cloudbeds', text: 'Cloudbeds' },
  { name: 'WooCommerce', text: 'WooCommerce' },
  { name: 'Shopify', text: 'Shopify' },
  { name: 'WordPress', text: 'WordPress' },
  { name: 'Wix', text: 'Wix' },
  { name: 'Joomla', text: 'Joomla' },
];

const CorporateTrust = () => {
  return (
    <section id="partners" className="relative py-20 md:py-24 bg-white border-y border-gray-100" data-testid="corporate-trust">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-[#C9A227] text-[10px] tracking-[0.4em] uppercase font-semibold">Trusted Integrations</span>
          <h2 className="text-[#0a1628] text-2xl md:text-3xl font-light mt-3 mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Connected to the World's <span className="text-[#C9A227] italic">Leading Financial &amp; Commerce Networks</span>
          </h2>
          <p className="text-gray-500 text-sm max-w-3xl mx-auto leading-relaxed">
            SAG platforms integrate with global payment networks, banks, eCommerce stacks, and secure communication providers —
            embedded in Shopify storefronts and external web applications where applicable, and connected to Wix, WordPress, Joomla,
            and standard websites through payment links, embedded checkout, custom integrations, and QuickPay tools.
          </p>
        </motion.div>
      </div>

      {/* Single-line horizontal scrolling marquee */}
      <div className="relative overflow-hidden">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <div className="flex animate-marquee hover:[animation-play-state:paused]">
          {[...partners, ...partners].map((p, i) => {
            const inner = p.logo ? (
              <img
                src={p.logo}
                alt={p.name}
                className={`${p.tall ? 'h-16 md:h-20' : 'h-10 md:h-12'} w-auto object-contain grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500`}
              />
            ) : (
              <span className="text-gray-400 text-base md:text-lg font-medium tracking-wide whitespace-nowrap group-hover:text-[#0a1628] group-hover:scale-110 transition-all duration-500">
                {p.text}
              </span>
            );
            return p.link ? (
              <a
                key={`${p.name}-${i}`}
                href={p.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 mx-10 md:mx-14 flex items-center justify-center group cursor-pointer"
                title={p.name}
              >
                {inner}
              </a>
            ) : (
              <div
                key={`${p.name}-${i}`}
                className="flex-shrink-0 mx-10 md:mx-14 flex items-center justify-center group"
                title={p.name}
              >
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CorporateTrust;
